import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { FreeMode, Navigation, Pagination, Thumbs } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/free-mode';
import 'swiper/scss/navigation';
import 'swiper/scss/thumbs';
import './index.scss';

import { ButtonCus } from '@/components/common/Button';
import { CarouselArrowLeft, CarouselArrowRight } from '@/components/icon/carousel/CarouselIcon';
import { cn } from '@/utils/utils';

interface ImagesBikeProps {
    images: any[]
}

export default observer(function ImagesBike({ images = [] }: ImagesBikeProps) {
    const [thumbsSwiper] = useState<any>(null);

    return (
        <div className=''>
            <Swiper
                loop={true}
                spaceBetween={30}
                pagination={{
                    clickable: true
                }}
                navigation={false}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[Pagination, FreeMode, Navigation, Thumbs]}
                className={cn(
                    'mySwiper2 overflow-visible sm:overflow-hidden',
                    images?.length > 1 && 'pb-[28px]'
                )}
            >
                {images?.length > 0 ?
                    (
                        images?.map(item => (
                            <SwiperSlide key={item?.id}>
                                <div
                                    className={cn(
                                        'w-full sm:w-[75%] max-w-[600px] aspect-[120/79] border-[0.355px] sm:border-[1px] border-border-gray bg-no-repeat bg-center bg-contain',
                                        !item?.filePath && 'bg-background-img'
                                    )}
                                    style={{
                                        backgroundImage: `url(${item?.filePath ?? ''})`
                                    }}
                                />
                            </SwiperSlide>
                        ))
                    ) :
                    (
                        <SwiperSlide>
                            <div className='w-full sm:w-[75%] max-w-[600px] aspect-[120/79] border border-border-gray bg-no-repeat bg-center bg-contain bg-background-img' />
                        </SwiperSlide>
                    )}

                {images?.length > 1 && (
                    <>
                        <SlidePrev />
                        <SlideNext />
                    </>
                )}
            </Swiper>
        </div>
    );
});

const SlidePrev = () => {
    const swiper = useSwiper();

    return (
        <ButtonCus
            type='button'
            variant='slide'
            size='slide'
            onClick={() => swiper.slidePrev()}
            className='absolute z-10 -left-[12.5px] sm:left-0 top-1/2 -translate-y-[calc(50%+12.5px)] sm:-translate-y-[calc(50%+15px)]'
        >
            <CarouselArrowLeft width={30} height={30} className='hidden sm:inline-block' />
            <CarouselArrowLeft width={25} height={25} className='inline-block sm:hidden' />
        </ButtonCus>
    );
};
const SlideNext = () => {
    const swiper = useSwiper();

    return (
        <ButtonCus
            type='button'
            variant='slide'
            size='slide'
            onClick={() => swiper.slideNext()}
            className='absolute z-10 -right-[12.5px] sm:right-0 top-1/2 -translate-y-[calc(50%+12.5px)] sm:-translate-y-[calc(50%+15px)]'
        >
            <CarouselArrowRight width={30} height={30} className='hidden sm:inline-block' />
            <CarouselArrowRight width={25} height={25} className='inline-block sm:hidden' />
        </ButtonCus>
    );
};
